export default "__VITE_ASSET__lmaCq23B__"